<div class="auth-wrapper">
  <div *ngIf="loader" id="loader"></div>

  <div class="hero card-glass mb-3">
    <p class="eyebrow">SoftPay · {{
      action === 'confirm' ? 'Confirmation' :
      action === 'return' ? 'Retour' :
      action === 'return-confirm' ? 'Retour vendeur' :
      action === 'subscription' ? 'Abonnement' :
      'Paiement'
    }}</p>
    <h1 *ngIf="action === 'pay' || action === 'subscription'">Paiement sécurisé</h1>
    <h1 *ngIf="action === 'confirm'">Confirmer la réception</h1>
    <h1 *ngIf="action === 'return'">Demande de retour</h1>
    <h1 *ngIf="action === 'return-confirm'">Confirmer le retour</h1>
    <p class="lead" *ngIf="action === 'pay'">Connectez-vous pour finaliser votre achat en toute confiance.</p>
    <p class="lead" *ngIf="action === 'subscription'">Connectez-vous pour régler votre abonnement en toute sécurité.</p>
    <p class="lead" *ngIf="action === 'confirm'">Confirmez que votre colis est reçu pour libérer le paiement.</p>
    <p class="lead" *ngIf="action === 'return'">Validez la demande de retour pour lancer le processus de remboursement.</p>
    <p class="lead" *ngIf="action === 'return-confirm'">Confirmez la réception du retour pour programmer le remboursement.</p>

    <div class="chips">
      <span class="chip" *ngIf="boutique">Boutique : {{ boutique }}</span>
      <span class="chip" *ngIf="articlenom">Article : {{ articlenom }}</span>
      <span class="chip" *ngIf="prixTotal">Total : {{ prixTotal | currency: sigle:'symbol':'0.0-0' }}</span>
    </div>

    <p *ngIf="problemAcure" class="alert-text danger mt-2">Données de connexion incorrectes.</p>
    <p *ngIf="soldeInsuifisant && action === 'pay'" class="alert-text warning mt-2">Solde insuffisant pour ce paiement.</p>
  </div>

  <div class="row justify-content-center g-4">
    <div class="col-lg-5 col-md-6" *ngIf="!hideloginform">
      <div class="card card-glass p-3">
        <div class="text-center mb-3">
          <img src="assets/icons/icon-96x96.png" width="96" height="96" alt="SoftPay logo">
          <h5 class="mt-2">Connexion</h5>
          <p class="text-muted small mb-0">Identifiez-vous pour continuer.</p>
        </div>

        <form [formGroup]="userLogin" #f="ngForm" (ngSubmit)="onlogin(f.value)" class="row g-3">
          <div class="col-12">
            <label class="form-label">Email ou téléphone</label>
            <input formControlName="username" id="username" name="username" type="text" class="form-control"
              placeholder="Votre email ou numéro" required autofocus>
          </div>
          <div class="col-12">
            <label class="form-label">Mot de passe</label>
            <input formControlName="password" name="password" type="password" class="form-control"
              placeholder="Mot de passe" required>
          </div>
          <div class="col-12 d-grid">
            <button type="submit" class="btn btn-primary btn-pill" [disabled]="!userLogin.valid">Continuer</button>
          </div>
        </form>
      </div>
    </div>

    <div class="col-lg-6 col-md-7" *ngIf="hideloginform">
      <div class="card card-glass p-3">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div>
            <p class="eyebrow">Résumé</p>
            <h5 class="mb-0">Vérifiez et confirmez</h5>
          </div>
          <span class="pill success" *ngIf="action === 'confirm'">Prêt à confirmer</span>
          <span class="pill info" *ngIf="action === 'return'">Demande de retour</span>
          <span class="pill info" *ngIf="action === 'return-confirm'">Confirmation vendeur</span>
          <span class="pill success" *ngIf="(action === 'pay' || action === 'subscription') && !soldeInsuifisant">Prêt à payer</span>
          <span class="pill danger" *ngIf="(action === 'pay' || action === 'subscription') && soldeInsuifisant">Solde insuffisant</span>
        </div>

        <dl class="summary">
          <div>
            <dt>Nom</dt>
            <dd>{{ firstname }} {{ lastname }}</dd>
          </div>
          <div>
            <dt>Compte</dt>
            <dd>{{ compte }}</dd>
          </div>
          <div *ngIf="action === 'pay' || action === 'subscription'">
            <dt>Solde</dt>
            <dd>{{ solde | currency: sigle:'symbol':'0.0-0' }}</dd>
          </div>
          <div *ngIf="action === 'pay' || action === 'subscription'">
            <dt>Montant</dt>
            <dd class="text-accent">{{ prixTotal | currency: sigle:'symbol':'0.0-0' }}</dd>
          </div>
          <div *ngIf="action === 'return' || action === 'return-confirm'">
            <dt>Montant concerné</dt>
            <dd class="text-accent">{{ prixTotal | currency: sigle:'symbol':'0.0-0' }}</dd>
          </div>
          <div *ngIf="action === 'return'">
            <dt>Action</dt>
            <dd class="text-accent">Demande de retour/remboursement</dd>
          </div>
          <div *ngIf="action === 'return-confirm'">
            <dt>Action</dt>
            <dd class="text-accent">Confirmation du retour (vendeur)</dd>
          </div>
          <div *ngIf="action === 'confirm'">
            <dt>Action</dt>
            <dd class="text-accent">Confirmer la réception</dd>
          </div>
        </dl>

        <div class="alert-text danger" *ngIf="errorMessage && (action === 'pay' || action === 'subscription')">
          Ce vendeur est introuvable. Vous allez être redirigé vers votre source.
        </div>
        <div class="alert-text warning" *ngIf="phoneNotConfirm && (action === 'pay' || action === 'subscription')">
          Vous devez confirmer votre numéro de téléphone.
        </div>
        <div class="alert-text warning" *ngIf="CNINotConfirm && (action === 'pay' || action === 'subscription')">
          Identité non confirmée ou en cours de confirmation.
        </div>
        <div class="alert-text danger" *ngIf="errorcompte && (action === 'pay' || action === 'subscription')">
          Ce compte client est introuvable.
        </div>

        <div class="d-flex gap-2 mt-3" *ngIf="(action === 'pay' || action === 'subscription') && !soldeInsuifisant">
          <button type="button" class="btn btn-success btn-pill flex-grow-1" (click)="confirmerPaiement()">
            Je confirme
          </button>
          <button type="button" class="btn btn-outline-light btn-pill" (click)="takemeBack(3)">
            J'annule
          </button>
        </div>
        <div class="d-grid mt-3" *ngIf="(action === 'pay' || action === 'subscription') && soldeInsuifisant">
          <button type="button" class="btn btn-outline-danger btn-pill" (click)="takemeBack(2)">
            Retourner
          </button>
        </div>
        <div class="d-grid mt-3" *ngIf="action === 'confirm'">
          <button type="button" class="btn btn-success btn-pill" (click)="confirmReception()">
            Je confirme la réception
          </button>
          <button type="button" class="btn btn-outline-light btn-pill" (click)="takemeBack(3)">
            J'annule
          </button>
        </div>
        <div class="d-grid mt-3" *ngIf="action === 'return'">
          <button type="button" class="btn btn-warning btn-pill" (click)="requestReturn()">
            Demander le retour
          </button>
          <button type="button" class="btn btn-outline-light btn-pill" (click)="takemeBack(3)">
            J'annule
          </button>
        </div>
        <div class="d-grid mt-3" *ngIf="action === 'return-confirm'">
          <button type="button" class="btn btn-success btn-pill" (click)="confirmReturn()">
            Confirmer le retour
          </button>
          <button type="button" class="btn btn-outline-light btn-pill" (click)="takemeBack(3)">
            J'annule
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-backdrop fade show" *ngIf="deviceChallenge"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="deviceChallenge" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content challenge-modal">
        <div class="modal-header border-0 pb-0">
          <div>
            <p class="eyebrow mb-1">Nouvel appareil</p>
            <h5 class="modal-title mb-0">Validation requise</h5>
          </div>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="closeDeviceChallenge()"></button>
        </div>
        <div class="modal-body pt-2">
          <p class="small mb-2">
            Un code OTP a été envoyé par
            <strong>{{ deviceChallenge.deliveryChannel || 'OTP' }}</strong>
            vers <strong>{{ deviceChallenge.maskedTarget || 'votre contact' }}</strong>.
          </p>
          <p class="small text-muted mb-3" *ngIf="challengeExpiryLabel">
            Expire le {{ challengeExpiryLabel }}.
          </p>

          <label class="form-label">Code OTP (6 chiffres)</label>
          <input [formControl]="deviceOtp" type="text" inputmode="numeric" maxlength="6" class="form-control"
            placeholder="Ex: 123456">
          <small class="text-danger" *ngIf="deviceOtp.invalid && deviceOtp.touched">
            Entrez un code valide de 6 chiffres.
          </small>
          <small class="text-danger d-block mt-2" *ngIf="deviceChallengeError">{{ deviceChallengeError }}</small>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-outline-light" (click)="closeDeviceChallenge()" [disabled]="validatingDevice">
            Annuler
          </button>
          <button type="button" class="btn btn-primary btn-pill" (click)="submitDeviceValidation()" [disabled]="validatingDevice">
            {{ validatingDevice ? 'Validation...' : 'Valider l’appareil' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
